import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  EmbeddedViewRef,
  NgZone,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core'

// TODO: expimenental
@Directive({
  selector: '[linAsyncList]',
  standalone: false,
})
export class AsyncListDirective implements OnInit, OnDestroy {
  private element: HTMLElement
  private parent: HTMLElement
  private observer: IntersectionObserver
  private timeoutId: any
  private embeddedViewRef: EmbeddedViewRef<any>

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly zone: NgZone,
    private readonly elementRef: ElementRef,
    private readonly viewContainer: ViewContainerRef,
    private readonly templateRef: TemplateRef<any>,
  ) {}

  ngOnInit() {
    this.element = this.elementRef.nativeElement
    this.parent = this.element.parentElement
    this.renderInitial()
  }

  renderInitial() {
    const { element, parent } = this
    const siblings = Array.from(parent.childNodes)
    const index = siblings.indexOf(element)
    const previousNodes = siblings.slice(0, index)
    const previousElement = previousNodes.reverse().find((node) => !(node instanceof Comment)) as HTMLElement | undefined

    if (!previousElement || this.isVisible(previousElement)) {
      this.createEmbeddedView()
    } else {
      this.timeoutId = setTimeout(() => this.createEmbeddedView(), index * 2)
    }
  }

  private createEmbeddedView() {
    this.embeddedViewRef = this.viewContainer.createEmbeddedView(this.templateRef)
    this.initObserver(this.embeddedViewRef.rootNodes[0])
  }

  initObserver(element: HTMLElement) {
    const options = { root: this.parent, threshold: 0 }

    this.zone.runOutsideAngular(() => {
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.embeddedViewRef.reattach()
        } else {
          this.embeddedViewRef.detach()
        }
      }, options)
      this.observer.observe(element)
    })
  }

  private isVisible(element: HTMLElement) {
    const parent = element.parentElement
    const offset = element.getBoundingClientRect().top - parent.getBoundingClientRect().top
    const isVisible = offset >= 0 && offset <= parent.clientHeight + parent.scrollTop

    return isVisible
  }

  ngOnDestroy() {
    clearTimeout(this.timeoutId)
    this.viewContainer.clear()
    this.observer && this.observer.disconnect()
  }
}
